import styled, { css } from 'styled-components';

export const CommodityListStyled = styled.div`
  height: 100%;
  overflow-y: auto;
  ${({ theme }) => css`
    padding-bottom: ${theme.spacings[800]};
  `}
`;
